import { ManfrediteLinkedinProfileAuthCallbackRequest } from './manfredite-linkedin-profile-auth-callback.request';
export const createMockedManfrediteLinkedinProfileAuthCallbackRequest = (customValues = {}) => {
    const request = new ManfrediteLinkedinProfileAuthCallbackRequest();
    request.code = customValues.code ?? '1a8b791f-c8d9-40b3-aabc-bbf6560a00da';
    request.state = customValues.state ?? '1a8b791f-c8d9-40b3-aabc-bbf6560a00da';
    return request;
};
export const createMockedManfrediteLinkedinProfileAuthCallbackErrorRequest = (customValues = {}) => {
    const request = new ManfrediteLinkedinProfileAuthCallbackRequest();
    request.state = customValues.state ?? '1a8b791f-c8d9-40b3-aabc-bbf6560a00da';
    request.error = customValues.error ?? 'member_access_denied';
    request.error_description = customValues.error_description ?? 'This functionality is not available to the member';
    return request;
};
//# sourceMappingURL=manfredite-linkedin-profile-auth-callback.request.mock.js.map